<div class="badge-wrapper">
  <ng-content></ng-content>

  <span
    class="badge"
    [ngClass]="[positionClass, hasValue ? 'with-value' : '', pulse ? 'pulse' : '']">
    @if (hasValue) {
      {{ value }}
    }
  </span>
</div>
